import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class UpsellOrderRepositoryService extends BaseRepositoryService<
  ModelRegistry['upsell-order']
> {
  recordName = 'upsell-order';
  implementMethods = ['query'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/upsell-order': UpsellOrderRepositoryService;
  }
}
